import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./app/App";
import { AuthProvider } from "./features/auth/AuthProvider";
import { AppConfigProvider } from "./shared/config/AppConfigProvider";
import "./styles/global.css";
import "./styles/sprint45.css";
import "./styles/sprint5a.css";
import "./styles/phase1.css";
import "./styles/release1.css";
import "./styles/phase3.css";
import "./styles/phase4.css";
import "./styles/pilot-validation.css";
import "./styles/operations-test.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 }
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppConfigProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AppConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
